import { Link } from 'react-router-dom'

export const TopSellingCard = ({ item }) => {
  return (
    <Link to={`/retailers/${item.shopSlug}/products/${item.productSlug}`}>
      <div className="flex-shrink-0 w-32">
        <div className="relative h-28 rounded-md overflow-hidden mb-2 bg-background flex items-center justify-center">
          <img
            src={item.primaryImageUrl}
            alt={item.productName || 'Top selling item'}
            className="object-contain max-h-full max-w-full"
          />
        </div>
        <div className="space-y-1">
          <p className="text-sm font-medium text-white truncate text-center">
            {item.productName || 'Product Name'}
          </p>
          <p className="text-xs text-white/70 truncate text-center">{item.categoryName}</p>
          <p className="text-sm font-bold text-secondary-600 text-center">
            {item.priceText || 'Price N/A'}
          </p>
        </div>
      </div>
    </Link>
  )
}
